import { render, staticRenderFns } from "./SistemaEducativo.vue?vue&type=template&id=67bbf8fa&"
import script from "./SistemaEducativo.vue?vue&type=script&lang=js&"
export * from "./SistemaEducativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports